<template>
    <div 
        v-b-tooltip.hover="{disabled: noTooltip }" :title="getTooltipValue"
        class="d-flex align-items-center small tenant-user-badge"
        :class="tuData.is_external ? 'tenant-user-badge-external' : 'tenant-user-badge-internal'"
    >
        <b-icon :icon="tuData.is_external ? 'person' : 'person-fill'" class="tu-user-icon"></b-icon>
        <span class="tu-name">{{ tuData.full_name }}</span>
        <b-icon v-if="deselectable" icon="x" class="tu-deselect-icon" font-scale="1.5" @click="emitDeselect"></b-icon>
    </div>
</template>

<script>
import has from 'lodash/has';

export default {
    name: 'TenantUserBadge',
    props: {
        tuData: {  // at least need initials, full_name, is_external
            type: Object,
            required: true,
        },
        deselectable: {  // if true, will show an X to 'deselect' this TU, and will emit 'deselect' event with full TU object
            type: Boolean,
            default: false,
        },
        tooltipValue: {  // choices are 'email' or 'int_ext' (shows internal/external)
            type: String,
            default: 'email',
        },
        noTooltip: {  // turn off the standard tooltip for "internal / external user"
            type: Boolean,
            default: false,
        }
    },
    data: function() {
        return {}
    },
    computed: {
        getTooltipValue: function() {
            // dynamically return the string to put into the tooltip based on tooltipValue prop
            // handle defaults or fallbacks if data isn't there
            if (this.tooltipValue === 'email') {
                return this.tuData.email || '';
            }
            if (this.tooltipValue === 'int_ext' && has(this.tuData, 'is_external')) {
                return this.tuData.is_external ? 'External User' : 'Internal User';
            }
            return '';  // complete fallback
        }
    },
    methods: {
        emitDeselect: function() {
            this.$emit('deselect', this.tuData);
        },
    },
}
</script>

<style lang="scss">

$tu-badge-outer-spacing: 0.5rem;
$tu-badge-inner-spacing: 0.25rem;
$tu-badge-vertical-spacing: 2px;

.tenant-user-badge {
    
    padding-left: 0;  // put padding on internal things instead
    padding-right: 0;  // put padding on internal things instead
    font-weight: 500;
    border-radius: 1rem;

    &.tenant-user-badge-external {
        background-color: var(--gray-100);
        //background-color: rgba(0,0,0,0.03);  // better for using on variety of backgrounds?
        color: var(--gray-700);
        border: 1px solid var(--danger-200);
        .b-icon {
            color: var(--danger-400);
        }
    }
    &.tenant-user-badge-internal {
        background-color: var(--gray-100);
        //background-color: rgba(0,0,0,0.03);  // better for using on variety of backgrounds?
        color: var(--gray-700);
        border: 1px solid var(--primary-200);
    }

    .tu-user-icon {
        margin-left: $tu-badge-inner-spacing;
        margin-right: $tu-badge-inner-spacing;
        &:first-child {
            margin-left: $tu-badge-outer-spacing;
        }
    }
    .tu-name {
        margin-left: $tu-badge-inner-spacing;
        margin-right: $tu-badge-inner-spacing;
        padding-top: 2px; 
        padding-bottom: 2px;
        &:last-child {
            margin-right: $tu-badge-outer-spacing;
        }
    }
    .tu-deselect-icon {
        cursor: pointer;
        margin-right: 0.25rem;
        margin-left: 0;
        border-radius: 2rem;
        &:hover {
            color: #000;
            background-color: rgba(0,0,0,0.1);
        }
    }


}


</style>